module.exports = __webpack_public_path__ + "static/media/21ECLAC35.d3af7cc4.jpg";